import Http from "util/https";
import { API_URL } from "config";

type CheckUploadStatusResponse = {
  result: 0 | 1 | 2; // 0: アップロード失敗, 1: アップロード成功, 2: アップロード中
};

type CheckUploadStatusResponseApi = {
  is_error_exists: boolean;
}

/**
 * 前回のCSVアップロード状態をチェックするAPI
 * @returns アップロードが成功したかどうか、エラーがあるかどうか
 */
export default async function checkUploadStatusApi(): Promise<CheckUploadStatusResponse> {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/weekly/csv/operation?operation=1`;
  const res = await http.get<CheckUploadStatusResponseApi>(url, {});
  console.log(res);

  // const res: { data: CheckUploadStatusResponseApi } = { data: { is_error_exists: true } }; // テスト用のダミーデータ
  return { result: res.data.is_error_exists ? 0 : 1 };
}
